import React, { useEffect } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import WizardStepDeleteButton
  from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/WizardStepDeleteButton';
import fr from 'facet-rest';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import { Box, FDBox } from '@facet-wealth/design';
import FileUploadDropAreaWithAttachmentList
  from 'Components/ComponentLibrary/Molecules/FileUploadDropAreaWithAttachmentList';
import ErrorList from 'Components/UI/ErrorList';

export default function Content({
  setCollection,
  refreshCollection,
}) {
  const {
    resource,
  } = useMetaLayoutContext();

  const [relevantAttachments, setRelevantAttachments] = React.useState(null);
  const [errs, setErrs] = React.useState([]);
  const getRelevantAttachments = async () => {
    const documents = await resource.relationship(fr.relationships.relevantAttachments.name)?.link('related').get();
    setRelevantAttachments(documents);
  };

  useEffect(() => {
    getRelevantAttachments();
  }, []);

  async function handleDelete() {
    if (resource.id() > 0 && resource.meta().action('DELETE')) {
      return resource.delete();
    }
    return null;
  }

  function handleDeleteSuccess(responseCollection) {
    setCollection(responseCollection);
  }

  const handleSuccessOrDelete = async () => {
    setErrs([]);
    await refreshCollection();
    await getRelevantAttachments();
  };

  const handleError = async (e) => {
    await handleSuccessOrDelete();

    if (e.response?.data?.errors?.length > 0) {
      setErrs(e.response?.data?.errors);
    }
  };


  return <>
    <PageContentContainer>
      <PageContentTop
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <Box width={'100%'}>
        <MetaFormFields resource={resource} />
        {resource.meta().action('DELETE') ? <WizardStepDeleteButton
          onDelete={handleDelete}
          onDeleteSuccess={handleDeleteSuccess}
          dialogProps={{
            title: 'Are you sure?',
            message: 'Removing this item will delete all of its information. This cannot be undone.',
            cancelLabel: 'Nevermind',
            confirmLabel: 'Remove',
          }}
        /> : null}

        <FileUploadDropAreaWithAttachmentList
          trailingTitleText={resource.attr('uploadTrailingTitle') ? resource.attr('uploadTrailingTitle') : 'your documents'}
          subtitle={resource.attr('uploadAcceptedFileTypes') ? resource.attr('uploadAcceptedFileTypes') : 'JPG, PNG, PDF with max file size 50MB'}
          url={resource.withRelationship(
            fr.relationships.uploadAttachment.name,
            (uploadRel) => uploadRel.link('related').url(),
            () => null,
          )}
          acceptedFileTypes={resource.attr('uploadAcceptedFileTypes') ? resource.attr('uploadAcceptedFileTypes') : 'image/*,.pdf'}
          attachments={relevantAttachments?.resources()?.list()}
          multiple={resource.withRelationship(
            fr.relationships.uploadAttachment.name,
            () => true,
            () => false,
          )}
          onSuccess={handleSuccessOrDelete}
          onError={handleError}
          errorMessage={errs.length > 0 ? errs[0]?.detail : null}
          onDelete={handleSuccessOrDelete}
          confirmOnDelete
        />
        <FDBox paddingY={2}>
          <ErrorList
            errors={errs}
            hideErrorTitle
          />
        </FDBox>
      </Box>
    </PageContentContainer>
  </>;
}
